var _g, _style, _style2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnlocked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 13.229 13.229",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Unlock",
    transform: "matrix(.27137 0 0 .25569 88.581 108.38)",
    strokeWidth: 1.0044
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m-313.2-401.2h-3v-6.4c0-7.8 6.4-14.2 14.2-14.2 7.2 0 13.2 5.3 14.1 12.4l-2.9 0.4c-0.7-5.6-5.5-9.8-11.2-9.8-6.2 0-11.2 5-11.2 11.2v6.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m-289.3-374.2h-25.5c-2.6 0-4.8-2.1-4.8-4.8v-19.1c0-2.6 2.1-4.8 4.8-4.8h25.5c2.6 0 4.8 2.1 4.8 4.8v19.1c0 2.7-2.1 4.8-4.8 4.8zm-25.4-25.4c-0.9 0-1.6 0.7-1.6 1.6v19.1c0 0.9 0.7 1.6 1.6 1.6h25.5c0.9 0 1.6-0.7 1.6-1.6v-19.1c0-0.9-0.7-1.6-1.6-1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m-298.8-393.3c0 1.8-1.4 3.2-3.2 3.2s-3.2-1.4-3.2-3.2 1.4-3.2 3.2-3.2 3.2 1.5 3.2 3.2"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "-301.2 -393.3 -302.8 -393.3 -304.4 -383.7 -299.6 -383.7 -301.2 -393.3"
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill:#fff;}")), _style2 || (_style2 = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill:#fff;}")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlocked);
export default __webpack_public_path__ + "static/media/unlocked.df10b6069270e459bfd2c8524b6ce820.svg";
export { ForwardRef as ReactComponent };